export const environment = {
	production: true,
  appKey: 'Grip_FE_PROD',
	apiUrl: 'https://grip.mvtest.online/Api.Gateway/api',
	accessTokenType:"id_token" ,
  applicationId: 3,
  tenantId: 0,
  auth: {
      authority: 'https://dev-247992.oktapreview.com/oauth2/default',
      client_id: '0oancsjkebAtUYi780h7',
      redirect_uri: 'https://grip.mvtest.online/auth-callback',
      post_logout_redirect_uri: 'https://grip.mvtest.online/logout-callback',
    response_type: "code",
    scope: "openid profile email",
    filterProtocolClaims: true,
    loadUserInfo: false
  },
  languages: [
    'es.ts',
    'en.ts'
  ]
};
